<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <h3>Add Notification</h3>
          <br />
          <label class="form-control-label">
            Notification Preview
          </label>
          <UserNotification :userNotification="form" v-if="form" />

          <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
            <b-form
              ref="form"
              @reset.prevent="reset"
              role="form"
              @submit.prevent="handleSubmit(submitNotification)"
            >
              <label class="form-control-label">
                Notification Type
              </label>

              <b-radio-group
                rules="required"
                v-model="form.type"
                :options="types"
                name="Notification Type"
                @input="notificationChange"
                :id="type"
              />
              <validation-provider
                v-slot="{ errors }"
                :name="label"
                rules="required"
              >
                <input type="hidden" v-model="form.type" />
                <slot name="error">
                  <div
                    v-if="errors[0]"
                    class="invalid-feedback"
                    style="display: block;"
                  >
                    {{ errors[0] }}
                  </div>
                </slot>
              </validation-provider>
              <br />
              <label class="form-control-label">
                Notification Icon
              </label>
              <base-input v-model="form.icon" rules="required" />

              <label class="form-control-label">
                Fully qualified url
              </label>
              <base-input
                v-model="form.fullyQualifiedUrl"
                placedholder="https://www.example.com"
                name="Title"
              />

              <label class="form-control-label">
                Notification Title
              </label>
              <base-input v-model="form.title" rules="required" name="Title" />

              <label class="form-control-label">
                Notification Message
              </label>

              <base-textarea v-model="form.text" rows="10" />

              <br />

              <b-button type="submit">Add Notification</b-button>
            </b-form>
          </validation-observer>

          <hr />
        </b-card>
      </b-col>
      <b-col>
        <template v-if="notifications.length > 0">
          <b-card>
            <h3>Current Notifications</h3>

            <div
              v-for="(notification, index) in notifications"
              v-bind:key="index"
            >
              <UserNotification
                :userNotification="notification"
                :showDelete="false"
              />

              <a href="#" @click.prevent="deleteNotification(notification)"
                >Delete</a
              ><br /><br />

              <template v-if="index == 0">
                <br />
                <a href="#" @click.prevent="reset(notification)"
                  >Reset all users to this notification</a
                >
              </template>
              <hr />
            </div>
          </b-card>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import UserNotification from "@/views/Components/UserNotifications/UserNotification.vue";
export default {
  components: { UserNotification },
  created() {
    this.bindNotifications();
  },
  watch: {},
  methods: {
    notificationChange() {
      if (this.form.type == "PRIMARY") this.tempIcon = "fa-solid fa-megaphone";
      else if (this.form.type == "DANGER")
        this.form.icon = "fa-solid fa-message-exclamation";
      else if (this.form.type == "SUCCESS")
        this.form.icon = "fa-solid fa-message-check";
      else if (this.form.type == "INFO")
        this.form.icon = "fa-solid fa-face-party";
    },
    async bindNotifications() {
      let r = await this.$client.get("/api/userNotification/getNotifications");
      if (r.data.isSuccess) {
        this.notifications = r.data.value.notifications;
      }
    },
    async reset(notification) {
      let r = await this.$client.post("/api/userNotification/reset", {
        id: notification.id,
      });
      if (r.data.isSuccess)
        this.$emitter.emit("success", {
          message: "Users have been reset to this notification.",
        });
    },
    async deleteNotification(notification) {
      let r = await this.$client.post(
        "/api/userNotification/deleteNotification?id=" + notification.id
      );

      if (r.data.isSuccess) {
        await this.bindNotifications();
      }
    },
    async submitNotification() {
      if (!this.form.text || this.form.text == "") {
        this.$emitter.emit("error", "Please enter a notification message.");
        return;
      }

      let r = await this.$client.post(
        "/api/userNotification/addNotification",
        this.form
      );

      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          message: "The notification has been added.",
        });

        await this.bindNotifications();
        this.form = { type: "PRIMARY", icon: "fa-solid fa-megaphone" };
      }
    },
  },
  data() {
    return {
      notifications: null,
      form: { type: "PRIMARY", icon: "fa-solid fa-megaphone" },
      types: [
        { value: "PRIMARY", text: "Info" },
        { value: "DANGER", text: "Warning" },
        { value: "SUCCESS", text: "Success" },
        { value: "INFO", text: "New Release" },
      ],
    };
  },
};
</script>

<style></style>
,
